import { atom, useAtom } from "jotai";

const inviteModalAtom = atom(false);

const useInvite = () => {
  const [inviteModalOpen, setInviteModalOpen] = useAtom(inviteModalAtom);

  return { inviteModalOpen, setInviteModalOpen };
};

export default useInvite;
